// extracted by mini-css-extract-plugin
export default {"block":"ContactInfo_block__zmv9r"};